import CampaignHeroModuleRenderer from './CampaignHeroModuleRenderer';

export * from './CampaignHeroModuleRenderer';

export default CampaignHeroModuleRenderer;
